import { useLayoutEffect, useRef } from 'react';

type UseChatScrollOptions = {
  container: HTMLElement | null;
  /**
   * Changes when the user's own message becomes the newest one. Replies do
   * not move the view: the column-reverse list keeps a reader at the bottom
   * on new messages and keeps a history reader in place.
   */
  scrollToLatestKey: string | number | undefined;
};

export const useChatScroll = ({
  container,
  scrollToLatestKey,
}: UseChatScrollOptions) => {
  const previous = useRef<{
    container: HTMLElement | null;
    scrollToLatestKey: string | number | undefined;
  } | null>(null);

  useLayoutEffect(() => {
    const previousState = previous.current;
    const hasNewOutgoingMessage =
      scrollToLatestKey !== undefined &&
      scrollToLatestKey !== previousState?.scrollToLatestKey;

    if (
      container &&
      (container !== previousState?.container || hasNewOutgoingMessage)
    ) {
      // The list uses column-reverse: its latest message is at offset zero.
      // Scroll before paint so the user never sees the jump.
      container.scrollTop = 0;
    }

    previous.current = { container, scrollToLatestKey };
  }, [container, scrollToLatestKey]);
};
